class Cart {
  constructor(el) {
    this.el = el
    this.cartCount = el.querySelector('[data-cart-count]')
    this.cartItemContainer = el.querySelector('[data-cart-items]')
    this.cartItems = el.querySelectorAll('[data-cart-item]')
    this.subtotalEl = el.querySelector('[data-cart-subtotal]')
    this.totalEl = document.querySelectorAll('[data-cart-total]')
  }

  init() {
    this.cartItems.forEach(el => {
      new CartItem(el, this.updateCart).init()
    })
  }

  updateCart = async (item, quantity) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Origin": "*"
    }

    const body = JSON.stringify({
      updates: {
        [item]: quantity
      }
    })

    try {
      const res = await fetch('/cart/update.js', {
        method: "POST",
        headers, body
      })

      const json = await res.json()
      console.log(json)
      this.cartCount.innerHTML = json.item_count
      const priceHtml = (json.total_price / 100).toLocaleString('en-US', {
        style: "currency",
        currency: "USD"
      }).replace('.00', '')

      this.subtotalEl.innerHTML = priceHtml
      this.totalEl.forEach(el => el.innerHTML = priceHtml)

      if(quantity === 0) {
        const removeItem = this.cartItemContainer.querySelector('[data-cart-item="' + item + '"]')
        removeItem.parentNode.removeChild(removeItem)
      }
    } catch(err) {
      console.error(err)
    }
  }
}

class CartItem {
  constructor(el, cb) {
    this.el = el
    this.cb = cb
    this.itemId = parseInt(el.getAttribute('data-cart-item'))
    this.quantitySelect = el.querySelector('[data-quantity-select]')
    this.inputEl = this.quantitySelect.querySelector('[data-item-qty]')
    this.plus = this.quantitySelect.querySelector('[data-item-plus]')
    this.minus = this.quantitySelect.querySelector('[data-item-minus]')
    this.quantity = parseInt(this.inputEl.value)
    this.remove = el.querySelector('[data-item-remove]')
    this.totalAvailable = parseInt(el.getAttribute('data-inventory-quantity'))
  }

  init() {
    this.initQuantitySelector()
    this.initRemoveBtn()
  }

  initQuantitySelector() {
    [this.plus, this.minus].forEach(button => {
      button.addEventListener('click', () => {
        //console.log(this.quantity, this.totalAvailable)
        if(this.quantity >= this.totalAvailable && button.value === '+') {
          this.inputEl.value = this.quantity
          return
        }

        if(this.quantity === 0 && button.value === '-') {
          this.inputEl.value = 0
          this.cb(this.itemId, 0)
          return
        }

        this.changeQuantity(button.value)
        this.inputEl.value = this.quantity

        new IdleTimer(() => this.cb(this.itemId, this.quantity))
      })
    })
  }

  changeQuantity(step) {
    this.quantity = step === '+' ? this.quantity + 1 : this.quantity - 1
  }

  initRemoveBtn() {
    this.remove.addEventListener('click', () => this.cb(this.itemId, 0))
  }
}

class IdleTimer {
  constructor(cb, interval) {
    this.idleTimer = null
    this.timer(cb, interval)
  }

  timer(cb, interval=500) {
    clearTimeout(this.idleTimer)
    this.idleTimer = setTimeout(cb, interval)
  }
}
